(() => {
  const subscribedKey = 'mio_email_signup_confirmed';
  const pendingKey = 'mio_signup_pending';
  const dismissedKey = 'mio_popup_dismissed';
  const get = (key, storage = 'localStorage') => {
    try {
      return window[storage].getItem(key);
    } catch {
      return null;
    }
  };
  const set = (key, value, storage = 'localStorage') => {
    try {
      window[storage].setItem(key, value);
    } catch {
      /* Signup remains available without storage. */
    }
  };
  let confirmed = get(subscribedKey) === 'true';
  let pending;
  try {
    pending = JSON.parse(get(pendingKey, 'sessionStorage') || 'null');
  } catch {
    pending = null;
  }

  document.querySelectorAll('[data-mio-signup-status]').forEach((status) => {
    const form = status.closest('form');
    if (!form || form.dataset.mioSignupBound) return;
    form.dataset.mioSignupBound = 'true';
    const ownResponse = window.location.hash === `#${form.id}`;
    const card = form.closest('[data-mio-signup-card]');
    if (status.dataset.status === 'success' && ownResponse) {
      if (pending?.form === form.id && Date.now() - pending.at >= 0 && Date.now() - pending.at < 30 * 60 * 1000) {
        confirmed = true;
        set(subscribedKey, 'true');
        try {
          sessionStorage.removeItem(pendingKey);
        } catch {
          /* Storage is optional. */
        }
      }
      if (card) {
        card.dataset.submitted = 'true';
        card.querySelector('.mio-popup__success').dataset.visible = 'true';
      }
    }
    if (status.dataset.status === 'error' && ownResponse && card) {
      const error = card.querySelector('.mio-popup__error');
      error.textContent = error.dataset.serverError;
      error.dataset.visible = 'true';
    }
    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      set(pendingKey, JSON.stringify({ form: form.id, at: Date.now() }), 'sessionStorage');
    });
  });

  const overlay = document.getElementById('MioNewsletterPopup');
  const tab = document.getElementById('MioOfferTab');
  if (!overlay || !tab) return;
  const form = document.getElementById('MioPopupForm');
  const status = document.getElementById('MioPopupFormStatus').dataset.status;
  const email = document.getElementById('MioPopupEmail');
  const title = document.getElementById('MioPopupTitle');
  const ownResponse = window.location.hash === '#MioPopupForm';
  let blockedCustomer = confirmed || overlay.dataset.knownCustomer === 'true';
  let dismissedThisPage = false;
  let openedThisPage = false;
  let previousFocus;
  let previousOverflow = '';
  let backdropPointer = false;
  let backdropWhileEditing = false;
  let delayElapsed = false;
  let engaged = false;
  const focusHeading = () =>
    (status === 'success' && ownResponse ? overlay.querySelector('.mio-popup__success-text') : title).focus({
      preventScroll: true,
    });
  const isOpen = () => overlay.dataset.open === 'true';
  const dismissed = () => {
    const at = Number(get(dismissedKey));
    return dismissedThisPage || (at > 0 && Date.now() >= at && Date.now() - at < 30 * 86400000);
  };
  const otherSurfaceOpen = () =>
    !!document.querySelector(
      'cart-drawer.active, .menu-drawer-container[open], .header__search details[open], body.mio-sheet-open, dialog[open]',
    );
  const editing = () => !!document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  // The floating tab covers the buy box on product and cart pages, so it only shows elsewhere.
  const refreshTab = () => {
    tab.hidden = blockedCustomer || isOpen() || overlay.dataset.tabEligible === 'false';
  };
  const open = (manual = false, response = false) => {
    if (isOpen() || (!response && blockedCustomer) || otherSurfaceOpen()) return;
    if (!manual && !response && editing()) return;
    openedThisPage = true;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    overlay.inert = false;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.dataset.open = 'true';
    tab.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('mio-is-signup-open');
    refreshTab();
    overlay.setAttribute(
      'aria-labelledby',
      response && status === 'success' ? 'MioPopupFormSuccessTitle' : 'MioPopupTitle',
    );
    requestAnimationFrame(() => {
      if (isOpen() && !overlay.contains(document.activeElement)) focusHeading();
    });
  };
  const close = () => {
    if (!isOpen()) return;
    if (status !== 'success' || !ownResponse) overlay.dispatchEvent(new CustomEvent('mio:popup-dismissed'));
    dismissedThisPage = true;
    set(dismissedKey, String(Date.now()));
    overlay.dataset.open = 'false';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.inert = true;
    tab.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow;
    document.body.classList.remove('mio-is-signup-open', 'mio-is-signup-editing');
    refreshTab();
    if (previousFocus?.isConnected && previousFocus !== document.body && previousFocus.getClientRects().length)
      previousFocus.focus({ preventScroll: true });
    else if (!tab.hidden) tab.focus({ preventScroll: true });
    else document.getElementById('MainContent')?.focus({ preventScroll: true });
  };
  tab.addEventListener('click', (event) => {
    event.preventDefault();
    open(true);
  });
  overlay.querySelector('[data-mio-popup-close]').addEventListener('click', close);
  overlay.querySelector('[data-mio-signup-continue]').addEventListener('click', (event) => {
    event.preventDefault();
    close();
  });
  overlay.addEventListener('pointerdown', (event) => {
    backdropPointer = event.target === overlay;
    backdropWhileEditing = form.contains(document.activeElement);
  });
  overlay.addEventListener('click', (event) => {
    if (
      event.target === overlay &&
      backdropPointer &&
      !backdropWhileEditing &&
      !email.value.trim() &&
      !form.contains(document.activeElement)
    )
      close();
    backdropPointer = false;
  });
  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...overlay.querySelectorAll('button, input, a[href], [tabindex="0"]')].filter(
      (el) => !el.disabled && el.getClientRects().length,
    );
    const first = focusable[0];
    const last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });
  document.addEventListener('focusin', (event) => {
    document.body.classList.toggle(
      'mio-is-signup-editing',
      !!event.target.closest('input, textarea, select, [contenteditable="true"]'),
    );
    if (isOpen() && !overlay.contains(event.target)) focusHeading();
  });
  document.addEventListener('focusout', () => {
    requestAnimationFrame(() => document.body.classList.toggle('mio-is-signup-editing', editing()));
  });
  window.addEventListener('storage', (event) => {
    if (event.key === subscribedKey && event.newValue === 'true') {
      blockedCustomer = true;
      if (isOpen()) close();
      refreshTab();
    }
  });
  window.addEventListener('pageshow', () => {
    if (isOpen() && !overlay.contains(document.activeElement)) focusHeading();
  });
  refreshTab();
  if (ownResponse && (status === 'success' || status === 'error')) {
    open(false, true);
    return;
  }
  if (blockedCustomer || dismissed() || overlay.dataset.autoEligible !== 'true') return;
  const params = new URLSearchParams(window.location.search);
  const paidMills =
    window.location.pathname.replace(/\/+$/, '') === '/collections/salt-pepper-mills' &&
    ((params.get('utm_campaign') || '').toLowerCase() === 'salt_pepper_mills' ||
      (params.get('utm_id') || params.get('campaign_id')) === '23860038610430793' ||
      ['paid_social', 'paid-social', 'paidsocial'].includes((params.get('utm_medium') || '').toLowerCase()) ||
      (['meta', 'facebook', 'instagram', 'fb', 'ig'].includes((params.get('utm_source') || '').toLowerCase()) &&
        ['paid', 'cpc'].includes((params.get('utm_medium') || '').toLowerCase())));
  if (paidMills) {
    overlay.dataset.mioPopupCampaignSuppressed = 'true';
    return;
  }
  const tryOpen = () => {
    if (delayElapsed && engaged && !openedThisPage && !dismissed() && !document.hidden) open();
  };
  window.addEventListener(
    'scroll',
    () => {
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0 && window.scrollY / distance >= 0.2) engaged = true;
      tryOpen();
    },
    { passive: true },
  );
  document.addEventListener('focusout', () => requestAnimationFrame(tryOpen));
  setTimeout(() => {
    delayElapsed = true;
    tryOpen();
  }, 20000);
})();
